import { render, staticRenderFns } from "./ClienteList.vue?vue&type=template&id=68c58ae0&scoped=true&"
import script from "./ClienteList.vue?vue&type=script&lang=js&"
export * from "./ClienteList.vue?vue&type=script&lang=js&"
import style0 from "./ClienteList.vue?vue&type=style&index=0&id=68c58ae0&lang=scss&scoped=true&"
import style1 from "./ClienteList.vue?vue&type=style&index=1&lang=scss&"
import style2 from "./ClienteList.vue?vue&type=style&index=2&lang=css&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "68c58ae0",
  null
  
)

export default component.exports